"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "RecordSubject", {
  enumerable: true,
  get: function () {
    return _search.RecordSubject;
  }
});
Object.defineProperty(exports, "SearchMode", {
  enumerable: true,
  get: function () {
    return _search.SearchMode;
  }
});
Object.defineProperty(exports, "SelfEvent", {
  enumerable: true,
  get: function () {
    return _search.SelfEvent;
  }
});
Object.defineProperty(exports, "createSearchDataModel", {
  enumerable: true,
  get: function () {
    return _search.createSearchDataModel;
  }
});
Object.defineProperty(exports, "demoPageQuerySet", {
  enumerable: true,
  get: function () {
    return _demoPage.demoPageQuerySet;
  }
});
Object.defineProperty(exports, "makeCanonicalizerAPI", {
  enumerable: true,
  get: function () {
    return _canonicalizer.makeCanonicalizerAPI;
  }
});
Object.defineProperty(exports, "mergeDataModels", {
  enumerable: true,
  get: function () {
    return _mergeDataModels.mergeDataModels;
  }
});
Object.defineProperty(exports, "searchQuerySet", {
  enumerable: true,
  get: function () {
    return _search.searchQuerySet;
  }
});
var _search = require("./querySets/search");
var _demoPage = require("./querySets/demo-page");
var _mergeDataModels = require("./mergeDataModels");
var _canonicalizer = require("./canonicalizer");